import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs';
import {
    IdentityVerificationStatus,
    PaymentVerification,
    PsVerificationStatus,
    UpdateUserVerification,
} from '../store/user/models/verifications.model';
import { UserVerificationState } from '../store/user/state/verification.state';
import { PSVerification, UserVerification } from './verification.types';

@Injectable({
    providedIn: 'root',
})
export class VerificationService {
    url = 'https://verification.coduluz.com/';

    constructor(private httpClient: HttpClient) {}

    updatePaymentSystemVerification(body: PaymentVerification) {
        const pSverification: PSVerification = {
            userId: body.userId,
            project: body.merchant,
            paymentSystemName: body.paymentSystem,
            payer: body.payer,
            isVerified: body.isVerified,
        };
        return this.editVerification(pSverification, 'payment-system-status');
    }

    updateUserIdentityVerification(body: UpdateUserVerification) {
        const userVerification: UserVerification = {
            userId: body.userId,
            project: body.merchant,
            isVerified: body.isVerified,
        };
        return this.editVerification(userVerification, 'identity-status');
    }

    getUserVerificationData(userId: string, merchant: string) {
        return this.httpClient
            .get(`${this.url}?userId=${userId}&project=${merchant}`)
            .pipe(
                catchError((error: any): any => {
                    throw new Error(error.message);
                }),
                map((response: any) => {
                    return response;
                })
            );
    }

    editVerification(body: any, endpoint: string) {
        return this.httpClient.post(`${this.url}${endpoint}`, body).pipe(
            catchError((error: any): any => {
                throw new Error(error.message);
            }),
            map((response: any) => {
                return response;
            })
        );
    }

    isUserNotFound(state: UserVerificationState): boolean {
        return (
            state.identityVerification ===
                IdentityVerificationStatus.NOT_FOUND &&
            !state.psVerification.verified?.length &&
            !state.psVerification.notVerified?.length
        );
    }
}
